export default {
    loaded: ({tournaments}) => tournaments.loaded,
    tournament: ({tournaments}) => tournaments.tournament,
    tournament_timestamp: ({tournaments}) => tournaments.tournament_timestamp
}